import { fbt } from 'fbtee'
import { Zap } from 'lucide-react'
import { useTransitionNavigate } from '../../../lib/viewTransition'
import { useNow } from '../../../hooks/useNow'
import { isEventLive } from '../../../lib/formatDate'
import { track } from '../../../lib/analytics'
import { OptionChip } from '../../../components/OptionChip'

// Entry point into festival mode (`/live-festival/:eventId`), an always-visible
// chip in the schedule's "more options" stack. Only rendered for festival-type events. Goes
// primary/active while the festival is currently live to signal the live view
// is useful right now.
export function FestivalModeFab({
  eventId,
  startDate,
  endDate,
  onTap,
  expanded,
}: {
  eventId: string
  startDate: string
  endDate?: string | null
  onTap?: () => void
  /** Show the text label (expanded) or render icon-only (collapsed). */
  expanded?: boolean
}) {
  const navigate = useTransitionNavigate()
  const now = useNow(60_000)
  const live = isEventLive({ startDate, endDate }, now)

  const label = live
    ? fbt('Festival is on', 'Schedule chip label for festival mode while the festival is happening')
    : fbt('Festival mode', 'Schedule chip label to enter festival mode')

  const title = live
    ? fbt('Festival is on now. Tap to open festival mode.', 'Tooltip on the festival-mode chip while the festival is happening')
    : fbt('Enter festival mode', 'Tooltip on the festival-mode chip')

  return (
    <OptionChip
      testId="festival-mode-fab"
      icon={<Zap className="size-5" />}
      label={label}
      title={title}
      active={live}
      showLabel={expanded}
      onClick={() => {
        onTap?.()
        track('enter_festival_mode', { event_id: eventId, live, entry_point: 'fab' })
        // Live, the schedule is where people spend their time in festival mode;
        // outside the window, Now is where the preview is offered.
        navigate(`/live-festival/${eventId}${live ? '/schedule' : ''}`, { replace: true })
      }}
    />
  )
}
